import HomeView from '@/views/HomeView.vue'
import Sidebar from '@/components/nav/NavComonents.vue'

export default [
    {
        path: '/systemManage',
        name: '系统管理',
        meta: {
            title: "系统管理",
        },
        redirect: '/systemManage/homeScrollSetting',
        leaf: false, //是否为单节点，增加属性
        menuShow: true,
        component: HomeView,
        icoClass: 'el-icon-user',
        children: [
            {
                path: '/systemManage/homeScrollSetting',
                name: "首页滚动图设置",
                meta: {
                    title: "首页滚动图设置",
                },
                // leaf: true, //是否为单节点，增加属性
                menuShow: true,
                icoClass: 'el-icon-user',
                components: {
                    default: () => import('@/views/systemManage/homeScrollSetting.vue'),
                    sidebar: Sidebar
                }
            },
            {
                path: '/systemManage/discoverScrollSetting',
                name: "发现滚动图设置",
                meta: {
                    title: "发现滚动图设置",
                },
                // leaf: true, //是否为单节点，增加属性
                menuShow: true,
                icoClass: 'el-icon-user',
                components: {
                    default: () => import('@/views/systemManage/discoverScrollSetting.vue'),
                    sidebar: Sidebar
                }
            },
            {
                path: '/systemManage/messageManag',
                name: "官方消息管理",
                meta: {
                    title: "官方消息管理",
                },
                // leaf: true, //是否为单节点，增加属性
                menuShow: true,
                icoClass: 'el-icon-user',
                components: {
                    default: () => import('@/views/systemManage/messageManag.vue'),
                    sidebar: Sidebar
                }
            },
            {
                path: '/systemManage/advertisingCooperation',
                name: "广告合作",
                meta: {
                    title: "广告合作",
                },
                // leaf: true, //是否为单节点，增加属性
                menuShow: true,
                icoClass: 'el-icon-user',
                components: {
                    default: () => import('@/views/systemManage/advertisingCooperation.vue'),
                    sidebar: Sidebar
                }
            },
            {
                path: '/systemManage/protocolSetting',
                name: "协议设置",
                meta: {
                    title: "协议设置",
                },
                // leaf: true, //是否为单节点，增加属性
                menuShow: true,
                icoClass: 'el-icon-user',
                components: {
                    default: () => import('@/views/systemManage/protocolSetting.vue'),
                    sidebar: Sidebar
                }
            },
            {
                path: '/systemManage/marginSettings',
                name: "保证金设置",
                meta: {
                    title: "保证金设置",
                },
                // leaf: true, //是否为单节点，增加属性
                menuShow: true,
                icoClass: 'el-icon-user',
                components: {
                    default: () => import('@/views/systemManage/marginSettings.vue'),
                    sidebar: Sidebar
                }
            },
            {
                path: '/systemManage/feedback',
                name: "意见反馈",
                meta: {
                    title: "意见反馈",
                },
                // leaf: true, //是否为单节点，增加属性
                menuShow: true,
                icoClass: 'el-icon-user',
                components: {
                    default: () => import('@/views/systemManage/feedback.vue'),
                    sidebar: Sidebar
                }
            },
            {
                path: '/systemManage/reportManage',
                name: "举报管理",
                meta: {
                    title: "举报管理",
                },
                // leaf: true, //是否为单节点，增加属性
                menuShow: true,
                icoClass: 'el-icon-user',
                components: {
                    default: () => import('@/views/systemManage/reportManage.vue'),
                    sidebar: Sidebar
                }
            },
            {
                path: '/systemManage/versionManage',
                name: "版本管理",
                meta: {
                    title: "版本管理",
                },
                // leaf: true, //是否为单节点，增加属性
                menuShow: true,
                icoClass: 'el-icon-user',
                components: {
                    default: () => import('@/views/systemManage/versionManage.vue'),
                    sidebar: Sidebar
                }
            },
            {
                path: '/systemManage/platformInfo',
                name: "平台信息",
                meta: {
                    title: "平台信息",
                },
                // leaf: true, //是否为单节点，增加属性
                menuShow: true,
                icoClass: 'el-icon-user',
                components: {
                    default: () => import('@/views/systemManage/platformInfo.vue'),
                    sidebar: Sidebar
                }
            },
        ]
    }
]